var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEntitiesLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Core-Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-88.000000, -654.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Entity",
    transform: "translate(88.000000, 654.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,21 C5.44771525,21 5,20.5522847 5,20 L5,4 C5,3.44771525 5.44771525,3 6,3 L18,3 C18.5522847,3 19,3.44771525 19,4 L19,20 C19,20.5522847 18.5522847,21 18,21 L6,21 Z M17,5 L7,5 L7,19 L11,19 L11,16 L13,16 L13,19 L17,19 L17,5 Z M11,11 L11,13 L9,13 L9,11 L11,11 Z M15,11 L15,13 L13,13 L13,11 L15,11 Z M11,7 L11,9 L9,9 L9,7 L11,7 Z M15,7 L15,9 L13,9 L13,7 L15,7 Z",
    id: "Combined-Shape",
    fill: "#677283"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntitiesLogo);
export default __webpack_public_path__ + "static/media/EntitiesLogo.2ea1441a.svg";
export { ForwardRef as ReactComponent };